/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MissionControllerDtoBasicAccountInfoListRequest model module.
 * @module model/MissionControllerDtoBasicAccountInfoListRequest
 * @version 1.0
 */
class MissionControllerDtoBasicAccountInfoListRequest {
    /**
     * Constructs a new <code>MissionControllerDtoBasicAccountInfoListRequest</code>.
     * @alias module:model/MissionControllerDtoBasicAccountInfoListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        MissionControllerDtoBasicAccountInfoListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>MissionControllerDtoBasicAccountInfoListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MissionControllerDtoBasicAccountInfoListRequest} obj Optional instance to populate.
     * @return {module:model/MissionControllerDtoBasicAccountInfoListRequest} The populated <code>MissionControllerDtoBasicAccountInfoListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MissionControllerDtoBasicAccountInfoListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('inviteCode')) {
                obj['inviteCode'] = ApiClient.convertToType(data['inviteCode'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MissionControllerDtoBasicAccountInfoListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MissionControllerDtoBasicAccountInfoListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of MissionControllerDtoBasicAccountInfoListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['inviteCode'] && !(typeof data['inviteCode'] === 'string' || data['inviteCode'] instanceof String)) {
            throw new Error("Expected the field `inviteCode` to be a primitive type in the JSON string but got " + data['inviteCode']);
        }

        return true;
    }


}

MissionControllerDtoBasicAccountInfoListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
MissionControllerDtoBasicAccountInfoListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
MissionControllerDtoBasicAccountInfoListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
MissionControllerDtoBasicAccountInfoListRequest.prototype['skip'] = undefined;

/**
 * @member {Number} accountNo
 */
MissionControllerDtoBasicAccountInfoListRequest.prototype['accountNo'] = undefined;

/**
 * @member {String} inviteCode
 */
MissionControllerDtoBasicAccountInfoListRequest.prototype['inviteCode'] = undefined;






export default MissionControllerDtoBasicAccountInfoListRequest;

